import React from 'react';

export const PlusIcon = ({ className }) => {
    return (
        <svg
            width="15"
            height="15"
            viewBox="0 0 15 15"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            className={className}
        >
            <path
                d="M7.5 1.25C10.9519 1.25 13.75 4.04813 13.75 7.5C13.75 10.9519 10.9519 13.75 7.5 13.75C4.04813 13.75 1.25 10.9519 1.25 7.5C1.25 4.04813 4.04813 1.25 7.5 1.25ZM7.5 4.375C7.38673 4.375 7.27729 4.41603 7.19192 4.49048C7.10655 4.56493 7.05103 4.66778 7.03562 4.78L7.03125 4.84375V7.03125H4.84375C4.72499 7.03129 4.61066 7.0764 4.52388 7.15748C4.4371 7.23856 4.38433 7.34956 4.37623 7.46805C4.36814 7.58654 4.40532 7.70368 4.48027 7.79581C4.55522 7.88794 4.66234 7.94819 4.78 7.96438L4.84375 7.96875H7.03125V10.1562C7.03129 10.275 7.0764 10.3893 7.15748 10.4761C7.23856 10.5629 7.34956 10.6157 7.46805 10.6238C7.58654 10.6319 7.70368 10.5947 7.79581 10.5197C7.88794 10.4448 7.94819 10.3377 7.96438 10.22L7.96875 10.1562V7.96875H10.1562C10.275 7.96871 10.3893 7.9236 10.4761 7.84252C10.5629 7.76144 10.6157 7.65044 10.6238 7.53195C10.6319 7.41346 10.5947 7.29632 10.5197 7.20419C10.4448 7.11206 10.3377 7.05181 10.22 7.03562L10.1562 7.03125H7.96875V4.84375C7.96875 4.71943 7.91936 4.6002 7.83146 4.51229C7.74355 4.42439 7.62432 4.375 7.5 4.375Z"
                fill="currentColor"
            />
        </svg>
    );
};
